import React, { PureComponent, createRef } from 'react'
import { withPlugin } from '@flamingo_tech/funkgo'

import Slider from '../../common/Slider/Slider'
import SingleColumn from '../../common/List/SingleColumn'

// import Image from '../../common/Image/Image'
import ProductImage from '../../common/ProductImage/ProductImage'
import VideoPlayer from '../../common/Video/VideoPlayer'
import { rem as px2rem } from '../../../utils/remUtils'
import { adjustImageUrl } from '@flamingo_tech/funkgo-utils/imageUtils'

import styles from './ProductPhotoSwipe.module.css'
import cx from '../../../utils/className'
import Pressable from '../../common/Pressable/Pressable'

const ImageThumbnail = props => {
  const {
    itemIndex,
    currentIndex,
    onMouseOver,
    productTitle,
    ...imageProps
  } = props

  const thumbTitle =
    imageProps.title ||
    (productTitle && `${productTitle} gallery ${itemIndex + 1}`) ||
    `Gallery - ${itemIndex + 1}`

  return (
    <div onMouseOver={() => onMouseOver(itemIndex)}>
      <ProductImage
        objectFit="cover"
        {...imageProps}
        title={thumbTitle}
        tiny
        className={cx(styles.thumbnail, itemIndex === currentIndex && styles.highlighted)}
      />
    </div>
  )
}

class ProductPhotoSwipe extends PureComponent {

  state = {
    curIndex: null,
    showSwipeButton: false,
    sliderSpeed: 400,
    items: null
  }

  sliderEl = createRef()

  componentDidUpdate(prevProps) {

    const itemsChanged = prevProps.items &&
      JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)

    const indexChanged = prevProps.curImageIndex !== this.props.curImageIndex

    if (itemsChanged) {
      setTimeout(() => {
        this.sliderEl.current.slickGoTo(0)
        this.setState({
          curIndex: 0
        })
      }, 200)

    } else if (indexChanged) {
      this.sliderEl.current.slickGoTo(this.props.curImageIndex)
    }

    if (this.state.curIndex === null) {
      this.setState({
        curIndex: this.props.curImageIndex || 0
      })
    }
  }

  swipeChangeHandler = index => {
    this.setState({
      curIndex: index
    })
  }

  handleLeftSwipe = () => {
    this.setState({
      sliderSpeed: 400
    })
    this.sliderEl.current.slickPrev()
  }

  handleRightSwipe = e => {
    this.setState({
      sliderSpeed: 400
    })
    e.stopPropagation()
    this.sliderEl.current.slickNext()
  }

  handleHoverThumbnail = itemIndex => {
    this.setState({
      curIndex: itemIndex,
      sliderSpeed: 0
    })

    this.sliderEl.current.slickGoTo(itemIndex)
  }

  handleHoverSlider = () => {
    this.setState({
      showSwipeButton: true
    })
  }

  handleMouseOutSlider = () => {
    this.setState({
      showSwipeButton: false
    })
  }

  renderPageNum = length => {
    if (typeof this.state.curIndex === 'number') {
      return `${this.state.curIndex + 1}/${length}`
    }

    return `${this.props.curImageIndex + 1}/${length}`
  }


  handleVideoFailToLoad = () => {
    // hide video
    const items = this.props.items.filter(item => item.type !== 'VIDEO')

    this.setState({
      items
    })
  }

  render() {
    const style = this.props.height ? { height: px2rem(this.props.height) } : null
    const items = this.state.items || this.props.items
    const title = this.props.product && this.props.product.title

    const images = items.map((item, i) => {
      const imgTitle = item.title || (title && `${title} gallery ${i + 1}`) || `Gallery - ${i + 1}`
      return (
        <div key={item.id} className={styles.photoSwipe}>
          {
            item.type === 'VIDEO'
            ?
            <VideoPlayer src={item.videoUrl} poster={adjustImageUrl(item.src, {
              crop: {
                width: 486,
                height: 864
              },
              quality: 60
            })} className={cx(styles.photoWrapper, styles.videoWrapper, this.props.flexible && styles.flexible)} style={style} onFailToLoad={this.handleVideoFailToLoad}/>
            :
            (
              i === 0 || i === 1
              ?
              <div className={styles.firstImgWrapper}>
                <ProductImage objectFit="cover" {...item} className={cx(styles.photoWrapper, this.props.flexible && styles.flexible)} style={style} title={imgTitle} middle></ProductImage>
              </div>
              :
              <ProductImage objectFit="cover" {...item} className={cx(styles.photoWrapper, this.props.flexible && styles.flexible)} style={style} title={imgTitle} middle lazy></ProductImage>
            )
          }
        </div>
      )
    })

    if (images.length === 0) {
      return null
    }

    const isDesktop = this.props.$detector.isDesktop()
    const sliderSettings = {
      variableWidth: true,
      speed: 170
    }

    return (
      <div className={cx(styles.wrapper, isDesktop && styles.inDesktop, this.props.minSliderWrapper && styles.smallSize, this.props.swiperSize)} style={style}>
        {
          isDesktop ?
          <div className={cx(styles.desktopWrapper, this.props.flexible && styles.flexible)}>
            <div className={cx(styles.thumbnails, styles.leftSide)}>
              <SingleColumn
                childIs={ImageThumbnail}
                childItems={items}
                childOptions={{
                  onMouseOver: this.handleHoverThumbnail,
                  currentIndex: this.state.curIndex,
                  productTitle: title,
                }}
                onReachEnd={() => null}
              ></SingleColumn>
            </div>
            <div className={cx(styles.sliderWrapper, isDesktop && styles.inDesktop, styles.rightSide)} onScroll={e => e.stopPropagation()} onMouseEnter={this.handleHoverSlider} onMouseLeave={this.handleMouseOutSlider}>
              {

                this.state.showSwipeButton && <>
                  {
                    isDesktop ?
                    <>
                      <Pressable className={cx(styles.pcSwiperButton, styles.pcLeftButton)} onClick={this.handleLeftSwipe} ariaLabel={this.props.$i18n.transl('core.product.photoPrev')}>
                        <div className={styles.pcLeftButtonArrow} aria-hidden="true" />
                      </Pressable>
                      <Pressable className={cx(styles.pcSwiperButton, styles.pcRightButton)} onClick={this.handleRightSwipe} ariaLabel={this.props.$i18n.transl('core.product.photoNext')}>
                        <div className={styles.pcRightButtonArrow} aria-hidden="true" />
                      </Pressable>
                    </>
                    :
                    <>
                      <Pressable className={styles.leftButton} onClick={this.handleLeftSwipe} ariaLabel={this.props.$i18n.transl('core.product.photoPrev')} />
                      <Pressable className={styles.rightButton} onClick={this.handleRightSwipe} ariaLabel={this.props.$i18n.transl('core.product.photoNext')} />
                    </>
                  }
                </>
              }
              <Slider afterChange={this.swipeChangeHandler} ref={this.sliderEl} infinite={true} speed={this.state.sliderSpeed}>
                {images}
              </Slider>
            </div>
          </div>
          :
          <>
            <Slider initialSlide={this.props.curImageIndex} afterChange={this.swipeChangeHandler} ref={this.sliderEl} infinite={true} {...sliderSettings}>
              {images}
            </Slider>
            <div className={styles.pagination}>{this.renderPageNum(images.length)}</div>
          </>
        }
      </div>
    )
  }
}

export default withPlugin(ProductPhotoSwipe)
